import { ReactNode, Fragment } from "react";
import { useIntl } from "react-intl";
import Tooltip from "./Tooltip";
import { Box } from "@mui/material";
import { Img } from "Components/Img";
import { CIRCLE_CROWN_ICON } from "Assets/icons";

const CrownTooltip = ({
  title,
  children,
  isFull,
}: {
  title: ReactNode;
  children?: ReactNode;
  isFull?: boolean;
}) => {
  const t = useIntl();
  return (
    <Tooltip title={title}>
      <Box
        display="flex"
        alignItems="center"
        className={isFull ? "sponsored-label" : ""}
        sx={{
          padding: "2px 4px",
        }}
      >
        {children || (
          <Fragment>
            <Img src={CIRCLE_CROWN_ICON} alt="icon" className="crown-icon" />
            {isFull && <span>{t.formatMessage({ id: "premium" })}</span>}
          </Fragment>
        )}
      </Box>
    </Tooltip>
  );
};

export default CrownTooltip;
